import { Component } from '@angular/core';

@Component({
  selector: 'app-first-section-landing',
  templateUrl: './first-section-landing.component.html',
  styleUrls: ['./first-section-landing.component.scss']
})
export class FirstSectionLandingComponent {

  constructor() { }
}
